export const USER_INTRO_STEP = 'USER_INTRO_STEP';
export const USER_INTRO_STEP_SUCCESS = 'USER_INTRO_STEP_SUCCESS';
export const USER_INTRO_STEP_FAIL = 'USER_INTRO_STEP_FAIL';

export const COMPANY_INTRO_STEP = 'COMPANY_INTRO_STEP';
export const COMPANY_INTRO_STEP_SUCCESS = 'COMPANY_INTRO_STEP_SUCCESS';
export const COMPANY_INTRO_STEP_FAIL = 'COMPANY_INTRO_STEP_FAIL';

export const CURRENT_USER_INTRO_STEP = 'CURRENT_USER_INTRO_STEP';
export const CURRENT_USER_INTRO_STEP_SUCCESS =
  'CURRENT_USER_INTRO_STEP_SUCCESS';

export const CURRENT_COMPANY_INTRO_STEP = 'CURRENT_COMPANY_INTRO_STEP';
export const CURRENT_COMPANY_INTRO_STEP_SUCCESS =
  'CURRENT_COMPANY_INTRO_STEP_SUCCESS';
